<form [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="form-row">
        <label class="d-none d-sm-inline col-sm-3 col-form-label" for="firmenname{{index}}">
          <span *ngIf="!isKapgOrKapgaus" class="d-flex justify-content-between">
            <span>{{ 'COMMON_UI.JURISTISCHEPERSON.FIRMENNAME' | translate }}</span>
          </span>
          <span *ngIf="isKapgOrKapgaus" class="d-flex justify-content-between">
            <span>{{ 'COMMON_UI.JURISTISCHEPERSON_KAPG.FIRMENNAME' | translate }}</span>
          </span>
        </label>
        <div class="d-none d-sm-flex col-sm-1 common-ui-small-stammdaten-button">
            <common-ui-daten-uebernahme
                    (picked)="onFirmaPicked($event)"
                    [itemTemplate]="datenuebernahmeFirmenname"
                    [items]="stammdatenFirmenname" [readonly]="readonly"
                    context="UnternehmenJuristischePersonFirmenname"
                    imageOnly="true">
            </common-ui-daten-uebernahme>
        </div>

        <div class="col-sm-8">
            <input
                    type="text"
                    id="firmenname{{index}}"
                    class="form-control"
                    datevMessagePath="firmenname{{objectId}}"
                    formControlName="firmenname"
                    (change)="onNameChange()"
                    data-eric-id="Inhaber[1]/NNatPers[1]/Firmenname[1]"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>
    </div>
</form>

<ng-template #datenuebernahmeFirmenname let-item="item">
    <h4>
        {{ item }}
    </h4>
</ng-template>
